import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { observer } from 'mobx-react-lite'
import { useInterval, useStore } from 'hooks'
import { THEME } from 'utils'
import { applyFastlyParams } from 'utils'
import storage from 'lib/storage'
import LiveMeta from 'components/LiveMeta'
import VideoPlayer from 'components/VideoPlayer'
import TimeDependent from 'components/TimeDependent'
import StoriesStore from 'stores/stories'

import LazyLoad from 'components/LazyLoad'
const LiveComments = dynamic(() => import('components/SpotIMComments'), { ssr: false })

const LiveDetail = () => {
  const storiesStore = useStore(StoriesStore)
  const story = storiesStore.current
  const videoSource = storiesStore.currentVideoSource
  const viewerCount = storiesStore.viewerCount

  useEffect(() => {
    storiesStore.postViewerCount(story.id, storage.clientId)
  }, [story.id])

  useInterval(
    () => {
      storiesStore.postViewerCount(story.id, storage.clientId)
      storiesStore.findById(story.id)
    },
    120 * 1000,
    [story.id]
  )

  useInterval(
    () => {
      storiesStore.findViewerCount(story.id)
    },
    15 * 1000,
    [story.id]
  )

  return (
    <>
      <div className='container'>
        <div className='row row--main'>
          <div className='col col--main'>
            <div className='live'>
              <div className='row row--live'>
                <div className='col col--video'>
                  {story.post_type_meta.live.status === 'post' ? (
                    <img
                      className='live__thumbnail'
                      src={applyFastlyParams(story.post_type_meta.barstool_original?.image ?? story.thumbnail.raw, {
                        crop: '16:9'
                      })}
                      alt={story.title}
                    />
                  ) : (
                    <TimeDependent
                      date={story.post_type_meta.live.datetime}
                      renderBefore={() => (
                        <img
                          className='live__thumbnail'
                          src={applyFastlyParams(story.post_type_meta.barstool_original?.image ?? story.thumbnail.raw, {
                            crop: '16:9'
                          })}
                          alt={story.title}
                        />
                      )}
                      renderAfter={() => <VideoPlayer story={story} videoSource={videoSource} autoplay />}
                    />
                  )}
                </div>
                <div className='col col--content'>
                  <div className='live__content'>
                    <div className='live__header'>
                      <h1 className='live__title'>{story.title}</h1>
                      <LiveMeta story={story} viewerCount={viewerCount} />
                    </div>
                    <div>
                      <div className='live__comments'>
                        {story.post_type_meta.live.status === 'post' ? (
                          <div className='textCenter'>
                            <h2>Live event has ended</h2>
                            <p>
                              <Link href='/'>
                                <a className='btn btn--secondary btn--sm'>Return to homepage</a>
                              </Link>
                            </p>
                          </div>
                        ) : (
                          <LazyLoad offset={500} once>
                            <LiveComments story={story} />
                          </LazyLoad>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .row--live {
          margin-left: -15px;
          margin-right: -15px;
        }
        .row--live .col {
          padding-left: 0;
          padding-right: 0;
        }
        .col--video,
        .col--content {
          min-width: 100%;
          flex-basis: 100%;
        }
        .live__header {
          padding: 8px 10px;
          background-color: #ffffff;
          border-bottom: 1px solid ${THEME.COLORS.LIGHTGRAY};
        }
        .live__title {
          font-size: 16px;
          line-height: 20px;
          margin: 0;
        }
        .live__thumbnail {
          width: 100%;
        }
        .live__comments {
          padding: 4px 16px;
          background-color: white;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .row--main {
            margin-top: 24px;
            margin-bottom: 24px;
          }
          .row--live {
            margin-left: 0;
            margin-right: 0;
            flex-direction: row;
          }
          .col--video {
            min-width: 68%;
            flex-basis: 68%;
          }
          .col--content {
            min-width: 32%;
            flex-basis: 32%;
          }
          .live__header {
            padding-top: 16px;
          }
          .live__title {
            font-size: 20px;
            font-weight: bold;
            line-height: 25px;
          }
          .live__content {
            height: 100%;
            border: 1px solid ${THEME.COLORS.LIGHTGRAY};
            border-left: none;
          }
          .live__comments {
            height: 296px;
            overflow-y: auto;
          }
        }
      `}</style>
    </>
  )
}

export default observer(LiveDetail)
